<script>
import BestRecruitLayout from './components/MenuList'
import JobFuture from './components/JobFuture'
import Training from './components/Training'
import Multiple from './components/Multiple'
export default {
  page() {
    return {
      title: `菁英招募 | 成長在零壹`,
    }
  },
  components: {
    BestRecruitLayout,
    JobFuture,
    Training,
    Multiple,
  },
  props: {
    aboutCompany: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {}
  },
}
</script>
<template>
  <BestRecruitLayout>
    <JobFuture :future="aboutCompany.career"></JobFuture>
    <Training :training="aboutCompany"></Training>
    <Multiple :carousel-list="aboutCompany['training-photo']"></Multiple>
  </BestRecruitLayout>
</template>
<style lang="scss" module>
</style>
